import React, { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../../firebase";
import { Navbar } from "../../../Components/Navbar/Navbar";
import { Footer } from "../../../Components/Footer/footer";
import "./style.css";

interface CCM {
  id: string;
  title: string;
  description: string;
  pdf_url: string;
}

export function CCMPage() {
  const [headerImage, setHeaderImage] = useState("");
  const [description, setDescription] = useState("");
  const [ccms, setCcms] = useState<CCM[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      const docRef = doc(db, "site_content", "ccm_page");
      const snap = await getDoc(docRef);
      if (snap.exists()) {
        const data = snap.data();
        setHeaderImage(data.header_image || "");
        setDescription(data.description || "");
        setCcms(data.ccms || []);
      }
    };
    fetchData();
  }, []);

  return (
    <div className="page-container">
      <Navbar />
      {headerImage && (
        <div
          className="ccm-banner"
          style={{ backgroundImage: `url(${headerImage})` }}
        />
      )}
      <div className="page-content">
        <h1>Contracte Colective de Muncă</h1>
        <p className="ccm-description">{description}</p>

        <div className="ccm-list">
          {ccms.map((item) => (
            <div key={item.id} className="ccm-card">
              <h3>{item.title}</h3>
              <p>{item.description}</p>
              <a href={item.pdf_url} target="_blank" rel="noopener noreferrer">
                Descarcă PDF
              </a>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}
